	<template>
	<div>
		<pageheader :linkTo='linkTo'></pageheader>
		<div style="margin-top: 90px" class="home">
			<transition name="right">
				<div v-show="intro0" class="introduction-title">
					<img style="width: 25.21vw;" src="../assets/introduction_title_word@2x.png">
					<p class="main-description">最美证件照制作使用人像识别技术与图像处理算法为您带来专业又美丽的证件照，自动抠图、自然美颜、完美保真。普通寸照、财务会计、职业资格、旅游签证、图像采集等诸多类型的证件照规格，满足您的全方位多类型需求</p>
					<div class='download-container'>
						<div class='download-btn-container'>
							<div class='download-btn' @click="downloadForAndroid">
								<img src='../assets/download_btn_android.png'>Android 版下载
							</div>
							<div class='download-btn' @click="downloadForIos">
								<img src="../assets/download_btn_iphone.png">iPhone 版下载
							</div>

						</div>
						<div class='download-qrcode-container'>
							<img src='../assets/download_qrcode.png' />
							<div>扫描二维码下载</div>
						</div>
					</div>
				</div>
			</transition>

			<div class='image-swiper'>
				<img @click="swiperPrev" src="../assets/left-btn.png" class="swiper-button-pre">
				<div>
					<swiper :options="imageSwiperOption" ref="imageSwiper">
						<swiper-slide>

							<div class="slide-image slide-image-1-active"></div>

						</swiper-slide>
						<swiper-slide>
							<div class="slide-image slide-image-2-active"></div>
						</swiper-slide>
						<swiper-slide>
							<div class="slide-image slide-image-3-active"></div>
						</swiper-slide>
						<swiper-slide>
							<div class="slide-image slide-image-4-active"></div>
						</swiper-slide>

					</swiper>
					<div class="image-swiper-pagination"  slot="pagination"></div>
				</div>
				<img @click="swiperNext" src="../assets/right-btn.png" class="swiper-button-next">
			</div>

		</div>
		<div class='introduce'>

			<div>
				<div class='procedure-title'>
					<div class='description-main-title'>证件照全套制作流程</div>
					<div class='description-sub-title'>证件照制作一条龙服务</div>
				</div>
				<transition name="up">
					<div v-show="intro1" class="step-container">
						<div class="step">
							<img src='../assets/introduction_icon_one@2x.png' />
							<div class="step-word">
								<div class="step-title">
									<img src='../assets/introduction_number_one@2x.png' />
									<span>智能抠图</span>
								</div>
								<div class="step-description">一键自动抠除琐碎杂物背景</div>
							</div>
						</div>
						<div class='step-interval'></div>
						<div class="step">
							<img src='../assets/introduction_icon_two@2x.png'/>
							<div class="step-word">
								<div class="step-title">
									<img src='../assets/introduction_number_two@2x.png'/>
									<span>自动裁剪</span>
								</div>
								<div class="step-description">自动剪裁到证件照标准</div>
							</div>
						</div>
						<div class='step-interval'></div>
						<div class="step">
							<img src='../assets/introduction_icon_three@2x.png'/>
							<div class="step-word">
								<div class="step-title">
									<img src='../assets/introduction_number_three@2x.png'/>
									<span>自然美颜</span>
								</div>
								<div class="step-description">一键自然美颜打造精致五官</div>
							</div>
						</div>
						<div class='step-interval'></div>
						<div class="step">
							<img src='../assets/introduction_icon_four@2x.png'/>
							<div class="step-word">
								<div class="step-title">
									<img src='../assets/introduction_number_four@2x.png'/>
									<span>一键换装</span>
								</div>
								<div class="step-description">多款服装自动识别贴合人像</div>
							</div>
						</div>
					</div>
				</transition>
			</div>
			<div class='algorithm-title'>
				<div class='description-main-title'>功能强大的算法</div>
				<div class='description-sub-title'>保证证件照制作的合格性</div>
			</div>
			<div class='algorithm-description'>
				<transition name="up">
					<div v-show="intro2" class="algorithm-description-container left">
						<div class='algorithm-main-description'>证件照拍摄<span class='algorithm-strong'>环境检测</span>算法</div>
						<div class='algorithm-sub-description'>对拍摄者的人脸姿态、眼睛视线、双眼水平、肩膀水平，服装突出以及周边拍摄环境光照是否充足，光线是否均匀进行检测</div>
					</div>
				</transition>
				<transition name="left">
					<img v-show="intro2" src="../assets/introduction_image_one@2x.png"/>
				</transition>

			</div>
			<div class='algorithm-description'>
				<transition name="right">
					<img v-show="intro3" src="../assets/introduction_image_two@2x.png" />
				</transition>
				<transition name="up">
					<div v-show="intro3" class="algorithm-description-container right">
						<div class='algorithm-main-description'><span class='algorithm-strong'>人脸识别</span>算法以及人脸属性分析算法</div>
						<div class='algorithm-sub-description'>识别头部长度，双眼间距，中性表情，阴阳脸，是否对准墨镜或粗边黑框眼睛</div>
					</div>
				</transition>

			</div>
			<div class='algorithm-description'>
				<transition name="up">
					<div v-show="intro4" class="algorithm-description-container left">
						<div class='algorithm-main-description'>人像<span class='algorithm-strong'>自然美颜</span>算法</div>
						<div class='algorithm-sub-description'>保证证件照不失真的情况下，对人脸皮肤进行美白，磨皮，瘦脸处理，放大眼睛，提亮瞳孔，展现微笑唇。</div>
					</div>
				</transition>
				<transition name="left">
					<img v-show="intro4" src="../assets/introduction_image_three@2x.png" />
				</transition>
			</div>
			<div class='algorithm-description'>
				<transition name="right">
					<img v-show="intro5" src="../assets/introduction_image_four@2x.png" />
				</transition>
				<transition name="up">
					<div v-show="intro5" class="algorithm-description-container right">
						<div class='algorithm-main-description'><span class='algorithm-strong'>精美正装</span>自动贴合人像算法</div>
						<div class='algorithm-sub-description' id='algorithm-sub-description-4'>涵盖女装，男装，童装等多套正装模板，供用户任意选择。自动识别贴合人像，一键操作。</div>
					</div>
				</transition>

			</div>
			<div class='spec-container'>
				<div class='spec-title'>
					<div class='description-main-title'>海量证件照规格尺寸</div>
					<div class='description-sub-title'>600+种证件照规格，满足各类场景拍摄</div>
				</div>
				<div class='spec-swiper'>
					<swiper :options="introSwiperOption" ref="introSwiper">
						<swiper-slide>
							<div class='spec-slide-container'>
								<img src="../assets/introduction_size_one@2x.png" class="slide-image-size">
								<div class='spec-slide-title'>报名考试</div>
								<div class='spec-slide-description'>包含普通话、四六级、会计等各类职业资格考试</div>
							</div>
						</swiper-slide>
						<swiper-slide>
							<div class='spec-slide-container'>
								<img src="../assets/introduction_size_two@2x.png" class="slide-image-size">
								<div class='spec-slide-title'>常规寸照</div>
								<div class='spec-slide-description'>包含一寸、二寸、五寸等常规寸照</div>
							</div>
						</swiper-slide>
						<swiper-slide>
							<div class='spec-slide-container'>
								<img src="../assets/introduction_size_three@2x.png" class="slide-image-size">
								<div class='spec-slide-title'>图像采集</div>
								<div class='spec-slide-description'>包含社保证、身份证、驾驶证等各地的图像信息采集</div>
							</div>
						</swiper-slide>
						<swiper-slide>
							<div class='spec-slide-container'>
								<img src="../assets/introduction_size_four@2x.png" class="slide-image-size">
								<div class='spec-slide-title'>旅游签证</div>
								<div class='spec-slide-description'>包含美国、日本、泰国等各国的签证照片办理</div>
							</div>
						</swiper-slide>
						<swiper-slide>
							<div class='spec-slide-container'>
								<img src="../assets/introduction_size_five@2x.png" class="slide-image-size">
								<div class='spec-slide-title'>职业资格</div>
								<div class='spec-slide-description'>教师资格、职业医师、建造师等各职业资格证件照片编辑</div>
							</div>
						</swiper-slide>
						<swiper-slide>
							<div class='spec-slide-container'>
								<img src="../assets/introduction_size_six@2x.png" class="slide-image-size">
								<div class='spec-slide-title'>公务员</div>
								<div class='spec-slide-description'>涵盖全国各地公务员考试报名照片</div>
							</div>
						</swiper-slide>
					</swiper>
<!--					<div class="image-swiper-pagination"  slot="pagination"></div>-->
				</div>
			</div>

		</div>
		<pagefooter1></pagefooter1>
	</div>
</template>

<script>

function parseDom(arg) {
	var objE = document.createElement("div");
	objE.innerHTML = arg;
	return objE.childNodes;

}

export default {
	name: 'home',
	metaInfo: {
		title:'最美证件照-证件照换底色-自动美颜一寸照拍摄制作平台',
		meta: [

			{ name: 'title', content: '最美证件照-证件照换底色-自动美颜一寸照拍摄制作平台' },
			{ name: 'description', content:'最美证件照-在线证件照换底色,专业的一寸证件照在线拍摄软件.涵盖海量证件照尺寸,包含计算机等级考试,四六级,国考,会计,教师资格证考试报名照片,简历照,工作证等各类尺寸.智能图片裁剪,多套正装模板自动贴合人像.'},
			{ name: 'keywords', content:'证件照换底色,证件照尺寸,证件照,最美证件照,一寸照'},
		]
	},

	data(){
		return {
			scroll:0,
			intro0:false,
			intro1:false,
			intro2:false,
			intro3:false,
			intro4:false,
			intro5:false,
			imageSwiperOption:{
				loop : true,
				autoplay: {
					delay: 3000,
					stopOnLastSlide: false,
					disableOnInteraction: true,
				},
				effect : 'coverflow',
				slidesPerView:1.5,
				loopedSlides:3,
				centeredSlides: true,
				initialSlide:1,
				coverflowEffect: {
					rotate: 0,
					stretch:68,
					depth: 160,
					modifier:2,
					slideShadows: false,
				},
				pagination: {
					el: '.image-swiper-pagination',
					type: 'bullets',
					bulletClass:'image-swiper-pagination-bullet',
					bulletActiveClass:'active-image-swiper-pagination-bullet',
					clickable:true
				},
				on: {
					transitionStart: function() {

						let currentDom = document.getElementsByClassName("swiper-slide-active")[0];
						let allDom = document.getElementsByClassName("swiper-slide");


						for (let i = 0; i < allDom.length; i++) {
							const element = allDom[i];

							// element.appendChild(obj[0]);
							if (element.childNodes.length>2){
								element.removeChild(element.childNodes[2]);
								element.removeChild(element.childNodes[1]);

							}
							const className = element.childNodes[0].classList.item(1)||''

							if (currentDom!==allDom[i]){
								// console.log('className',className)
								let caseIndex=className.split('-')[2]
								switch (caseIndex) {
									case '1':
										element.childNodes[0].classList.remove('slide-image-1-active')
										element.childNodes[0].classList.add('slide-image-1-no-active')
										break
									case '2':
										element.childNodes[0].classList.remove('slide-image-2-active')
										element.childNodes[0].classList.add('slide-image-2-no-active')
										break
									case '3':
										element.childNodes[0].classList.remove('slide-image-3-active')
										element.childNodes[0].classList.add('slide-image-3-no-active')
										break
									case '4':
										element.childNodes[0].classList.remove('slide-image-4-active')
										element.childNodes[0].classList.add('slide-image-4-no-active')
										break

								}

							}

						}
						// const currentObj2=parseDom('<div :style="{background: \'url(\' + iphone_page2 + \') no-repeat 0% 20%/ cover\'}" class="slide-image"></div>')

						let currentObj = ''
						let currentObj1= ''
						const currentClassName = currentDom.childNodes[0].classList.item(1)
						let currentCaseIndex = currentClassName.split('-')[2]
						switch (currentCaseIndex) {
							case '1':
								currentDom.childNodes[0].classList.remove('slide-image-1-no-active')
								currentDom.childNodes[0].classList.add('slide-image-1-active')
								currentObj=	parseDom('<div style="color:rgba(53,49,92,1);font-size: 16px;margin: 18px 0 5px 0">自动抠图换底色</div>')
								currentObj1=parseDom('<div style="color:rgba(53,49,92,0.5);font-size: 12px">蓝/白/红等多套背景色任意选择</div>')
								break
							case '2':
								currentDom.childNodes[0].classList.remove('slide-image-2-no-active')
								currentDom.childNodes[0].classList.add('slide-image-2-active')
								currentObj=	parseDom('<div style="color:rgba(53,49,92,1);font-size: 16px;margin: 18px 0 5px 0">一键智能裁剪</div>')
								currentObj1=parseDom('<div style="color:rgba(53,49,92,0.5);font-size: 12px">寸照/签证照/考试照等500+规格</div>')
								break
							case '3':
								currentDom.childNodes[0].classList.remove('slide-image-3-no-active')
								currentDom.childNodes[0].classList.add('slide-image-3-active')
								currentObj=	parseDom('<div style="color:rgba(53,49,92,1);font-size: 16px;margin: 18px 0 5px 0">自然人像美颜</div>')
								currentObj1=parseDom('<div style="color:rgba(53,49,92,0.5);font-size: 12px">提亮/大眼/美肤/瘦脸</div>')
								break
							case '4':
								currentDom.childNodes[0].classList.remove('slide-image-4-no-active')
								currentDom.childNodes[0].classList.add('slide-image-4-active')
								currentObj=	parseDom('<div style="color:rgba(53,49,92,1);font-size: 16px;margin: 18px 0 5px 0">个性换正装</div>')
								currentObj1=parseDom('<div style="color:rgba(53,49,92,0.5);font-size: 12px">多套正装模板自动贴合人像</div>')
								break
						}

						currentDom.appendChild(currentObj[0]);
						currentDom.appendChild(currentObj1[0]);

					}

				}

			},
			introSwiperOption:{
				loop : true,
				// autoplay: false,
				autoplay: {
					delay: 3000,
					stopOnLastSlide: false,
					disableOnInteraction: true,
				},
				slidesPerView:4,


			},

		};
	},


	methods:{
		downloadForIos:function(){
			window.open("https://apps.apple.com/cn/app/%E8%AF%81%E4%BB%B6%E7%85%A7%E7%A0%94%E7%A9%B6%E9%99%A2-%E6%9C%80%E7%BE%8E%E8%AF%81%E4%BB%B6%E7%85%A7%E6%8B%8D%E6%91%84%E7%9B%B8%E6%9C%BA%E8%BD%AF%E4%BB%B6/id1202793547")
		},
		downloadForAndroid:function(){
			window.open("https://sj.qq.com/myapp/detail.htm?apkName=com.leqi.zuimeiphoto")
		},
		swiperPrev(){
			this.imageSwiper.slidePrev()
		},
		swiperNext(){
			this.imageSwiper.slideNext()
		},
		scrollHandle(){

			this.scroll = document.documentElement.scrollTop||document.body.scrollTop

			console.log(this.scroll);


			this.intro1=!this.intro1?this.scroll>30:true

			this.intro2=!this.intro2?this.scroll>480:true

			this.intro3=!this.intro3?this.scroll>936:true

			this.intro4=!this.intro4?this.scroll>1410:true

			this.intro5=!this.intro5?this.scroll>1860:true

		},
		scrollUp(){
			window.scrollTo(0,0)
		}
	},
	created() {
		this.linkTo=this.$route.path.substr(1)

	},
	mounted(){
		window.addEventListener('scroll',this.scrollHandle);//绑定页面滚动事件
		window.addEventListener('beforeunload',this.scrollUp)
		this.intro0=true
		// // console.log(this.$refs
		// this.$refs.imageSwiper.swiper.controller.control=this.$refs.wordSwiper.swiper;
		// this.$refs.wordSwiper.swiper.controller.control=this.$refs.imageSwiper.swiper

	},
	computed: {
		imageSwiper() {
			return this.$refs.imageSwiper.swiper
		},
		introSwiper() {
			return this.$refs.introSwiper.swiper
		}


	},
}
</script>

<style scoped="scoped">
.home{
	background-image: url(../assets/download_bg.png);
	background-size: cover;
	width: 100%;
	height: 730px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.main-description{
	margin: 40px 0 82px 0;
	color:rgba(102,102,102,1);
	line-height:32px;
	font-size:18px;
	width: 25.21vw;
}
.image-swiper{
	width: 500px;
	position: absolute;
	top: 175px;
	left: 51.35vw;
}
.swiper-wrapper{
	width: 500px;
}

.swiper-slide{
	display: flex;
	justify-content: center;
	/*background-color: white;*/
	/*padding: 18px 0;*/
	align-items: center;
	flex-direction: column;
	/*width: 120px;*/

}
.slide-image{
	width:240px;
	height: 495px;
	border-radius: 34px;
	background-size: contain;
}

.slide-image-1-active{
	background-image: url("../assets/iphone_page1.png");
}
.slide-image-1-no-active{
	background: linear-gradient(rgba(32,28,65,0.3),rgba(32,28,65,0.3)),url("../assets/iphone_page1.png") no-repeat 0% 20%/ cover;
}
.slide-image-2-active{
	background-image: url("../assets/iphone_page2.png");
}
.slide-image-2-no-active{
	background: linear-gradient(rgba(32,28,65,0.3),rgba(32,28,65,0.3)),url("../assets/iphone_page2.png") no-repeat 0% 20%/ cover;
}
.slide-image-3-active{
	background-image: url("../assets/iphone_page3.png");
}
.slide-image-3-no-active{
	background: linear-gradient(rgba(32,28,65,0.3),rgba(32,28,65,0.3)),url("../assets/iphone_page3.png") no-repeat 0% 20%/ cover;
}
.slide-image-4-active{
	background-image: url("../assets/iphone_page4.png");
}
.slide-image-4-no-active{
	background: linear-gradient(rgba(32,28,65,0.3),rgba(32,28,65,0.3)),url("../assets/iphone_page4.png") no-repeat 0% 20%/ cover;
}

.swiper-button-pre{
	width: 30px;
	position: absolute;top: 250px;left: 61px;
	background: none;
	z-index:10;
	cursor: pointer;
}
.swiper-button-next{
	width: 30px;
	height: 30px;
	position: absolute;top: 270px;right: 61px;
	background:none;
	z-index:10;
	cursor: pointer;
}

.word-container{
	display: inline-block;
	width: 450px;
	margin-left: 82px;
	position: relative;
	top: -20px;
}
.word-swiper-container{
	padding-left: 18px;
}

.introduction-title{
	left: 19vw;
	position: absolute;
	top:196px
}
.download-container{
	width: 386px;
	display: flex;
	justify-content: space-between;
	margin-top: 62px;
	margin-bottom: 47px;
	/*padding-left: 18px;*/
}
.download-btn-container{
	display: inline-flex;
	height: 146px;
	justify-content: space-between;
	flex-direction: column;
	padding: 7px 0;
	box-sizing: border-box;
}
.download-btn{
	width:200px;
	height:54px;
	background:rgba(255,123,172,1);
	box-shadow:0px 19px 19px 0px rgba(255,123,172,0.2);
	border-radius:28px;
	color:rgba(255,255,255,1);
	font-size:16px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor:pointer
}
.download-btn img{
	width:30px;
	height: 30px;
	margin-right: 10px;
}
.download-qrcode-container{
	width: 130px;
	/*height: 146px;*/
	display: inline-block;
	font-size:12px;
	color:rgba(153,153,153,1);
	text-align: center;
	padding: 6px 0px 0px 0px;
	background-color: white;
	box-shadow: 1px 1px 10px 0 #efefef;
}
.download-qrcode-container img{
	width: 114px;
	height: 114px;
	/*margin-bottom:3px;*/
}

.introduce>div{
	padding: 0 19%;
	box-sizing: border-box;
}
.step-container{
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 60px;
}
.procedure-title{
	text-align: center;
}
.procedure-title .description-main-title{
	width: 351px;
	height: 104px;
	background-image: url(../assets/process@2x.png);
	background-size: 317px 44px;
	background-repeat: no-repeat;
	background-position: 20px 20px;
	padding-top: 37px;
}
.step>img{
	width: 146px;
	height: 146px;
}
.step-title>img{
	width: 36px;
	height: 52px;
}
.step-title>span{
	font-weight:500;
	color:rgba(53,49,92,1);
	font-size:22px;
	position: relative;
	bottom: 8px;
}
.step-description{
	margin-top: 15px;
	font-size:14px;
	color:rgba(187,185,207,1);
	white-space:nowrap;
}
.step-interval{
	width: 118px;
	height: 0.1px;
	border: 1px rgb(216,216,216,0.5) dashed;
	box-sizing: border-box;
}
.algorithm-title{
	text-align: center;
	margin-top: 43px;
}
.algorithm-title .description-main-title{
	width: 401px;
	height: 106px;
	background-image: url(../assets/arithmetic@2x.png);
	background-size: 394px 45px;
	background-repeat: no-repeat;
	background-position: 0px 20px;
	padding-top: 33px;
}
.description-main-title{
	font-size:32px;
	font-weight:500;
	color:rgba(51,51,51,1);
	margin: 0 auto;
	box-sizing: border-box;
}
.description-sub-title{
	font-size:18px;
	color:rgba(153,153,153,1);
}
.algorithm-description{
	width: 100%;
	height: 460px;
	display: flex;
	justify-content: space-between;
}
.algorithm-description:nth-child(2n){
	background:rgba(249,249,249,1);
}
.algorithm-description:nth-child(2n+1){
	background:rgba(255,255,255,1);
}
.algorithm-description img{
	width: 390px;
	height: 460px;
	flex-shrink: 0;
}
.algorithm-description-container{
	display: flex;
	justify-content: center;
	flex-direction: column;
}
.algorithm-description-container.left{
	align-items: flex-start;
}
.algorithm-description-container.right{
	align-items: flex-end;
	text-align: right;
}
.algorithm-main-description{
	font-weight:500;
	color:#333333;
	font-size:32px;
}
.algorithm-sub-description{
	font-size:16px;
	font-weight:400;
	color:rgba(153,153,153,1);
	line-height:22px;
	width: 617px;
	margin-top: 19px;
}
#algorithm-sub-description-4{
	width: 644px;
}
.algorithm-strong{
	color: #FF7BAC;
}
.spec-container{
	padding: 0 0 !important;
	/* width: 100vw; */
	margin: 0 auto;
	width: 1185px;
}
.spec-swiper{
	/* 		padding: 0 0 !important;
      width: 100vw; */
	padding-top: 85px;
	padding-bottom: 68px;

}
/*.swiper-slide{*/
/*	display: flex;*/
/*	justify-content: center;*/
/*	background-color: white;*/
/*	padding: 18px 0;*/
/*}*/
/*.swiper-container{*/

/*}*/

.spec-title{
	text-align: center;
}
.spec-title .description-main-title{
	width: 306px;
	height: 106px;
	background-image: url(../assets/measure@2x.png);
	background-size: 298px 45px;
	background-repeat: no-repeat;
	background-position: 0px 20px;
	padding-top: 43px;
}
.spec-slide-container{
	width: 270px;
	height: 360px;
	display: flex;
	justify-content: space-around;
	align-items: center;
	flex-direction: column;
	box-shadow:2px 10px 10px 0px rgba(53,27,84,0.08);
	border-radius:6px;
	margin: 20px 0;
}
.slide-image-size{
	width: 100%;

}
.spec-slide-title{
	font-size:32px;
	font-weight:500;
	color:rgba(51,51,51,1);
}
.spec-slide-description{
	font-size:16px;
	font-weight:400;
	color:rgba(153,153,153,1);
	text-align: center;
}




.up-enter-active{
	animation:up .6s;
}
.down-enter-active{
	animation:down .6s;
}
.left-enter-active{
	animation:left .6s;
}
.right-enter-active{
	animation:right .6s;
}
@keyframes up {
	0% {
		transform: translateY(100%);
	}

	100% {
		transform: translateY(0px);
	}
}
@keyframes right {
	0% {
		transform: translateX(-100%);
	}

	100% {
		transform: translateX(0px);
	}
}
@keyframes left {
	0% {
		transform: translateX(100%);
	}

	100% {
		transform: translateX(0px);
	}
}
@keyframes down {
	0% {
		transform: translateY(-100%);
	}

	100% {
		transform: translateY(0px);
	}
}
</style>
